import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appForbiddenChars]',
    standalone: true,
})
export class ForbiddenCharsDirective {
    private forbidden = /[<>\/]/g;

    constructor(@Optional() private control: NgControl) {}

    @HostListener('input', ['$event'])
    onInput(event: any) {
        const original = event.target.value;
        const sanitized = original.replace(this.forbidden, '');

        if (sanitized !== original) {
            event.target.value = sanitized;

            if (this.control?.control) {
                this.control.control.setValue(sanitized, { emitEvent: false });
            }
        }
    }
}
